// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Retailers_skeleton__Tni1U","map":"Retailers_map__GUi0W","trigger":"Retailers_trigger__xvXMN"};